var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconReset48Line = function SvgIconReset48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.83 16.15a14.15 14.15 0 0 0-12.66-6.32l3.11-3.36-2.49-2.31L18.35 10a2.928 2.928 0 0 0-.76 2.15 2.889 2.889 0 0 0 1 2l6.12 5.14 2.19-2.61-4.13-3.47A10.8 10.8 0 1 1 16 16.78l-2.56-2.28a14.2 14.2 0 1 0 22.39 1.65Z",
    fill: "current"
  })));
};
export default SvgIconReset48Line;